<mat-card class="mat-card-flat" *ngIf="is_ready">
  <mat-card-content>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="5px">
      <ng-container *ngFor="let tab of period_list">
        <button type="button" mat-raised-button [color]="period && tab.period == period ? 'accent' : 'primary'"
          (click)="changePeriod(tab.period)">{{ tab.label | translate }}</button>
      </ng-container>
    </div>

  </mat-card-content>
</mat-card>
